import { RecurringFrequency } from "../../../../../collabration/tasks/TaskRecurringConfig";

type PatientAssessmentsReminderMediumEnum = "EMAIL" | "SMS";

export const SEND_PATIENT_ASSESSMENT_INITIAL_VALUES: PatientAssessment = {
  patientIds: undefined,
  selectedForms: undefined,
  recordedDate: undefined,
  recordedTime: undefined,
  medium: "EMAIL",
  isScheduled: false,
  isRecurring: false,
  recurringFrequency: undefined,
  reminder_set: false,
  reminders: {
    reminderBeforeNumber: 0,
    reminderBeforeUnit: "minutes",
    reminderMedium: ["EMAIL"],
  },
};

export const MEDIUM_LIST = [
  { value: "EMAIL", label: "Email" },
  { value: "SMS", label: "SMS" },
];

export type PatientAssessment = {
  patientIds?: any[];
  reminder_set?: boolean;
  isRecurring?: boolean;
  recurringFrequency?: RecurringFrequency;
  isScheduled?: boolean;
  scheduleTime?: string;
  reminderMedium?: PatientAssessmentsReminderMediumEnum;
  reminders?: {
    reminderBeforeNumber: number;
    reminderBeforeUnit: string;
    reminderMedium: string[];
  };
  selectedForms?: any[];
  recordedDate?: undefined;
  recordedTime?: undefined;
  medium?: PatientAssessmentsReminderMediumEnum;
};
